import React, { useState, useRef } from 'react';
import axiosInstance from '../../config/axiosConfig';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputOtp } from 'primereact/inputotp';
import { Toast } from 'primereact/toast';
import { FloatLabel } from 'primereact/floatlabel';
import { InputText } from 'primereact/inputtext';
import useUserStore from '../../store/useUserStore';

const EmailVerificationDialog = ({ visible, onHide }) => {
    const [loading, setLoading] = useState(false);
    const [codeSent, setCodeSent] = useState(false);
    const [otp, setOtp] = useState('');
    const email = useUserStore((state) => state.user.email);
    const toast = useRef(null);

    const sendVerificationEmail = async () => {
        setLoading(true);
        try {
            await axiosInstance.get('/dashboard/user/me/sendVerificationEmail');
            setCodeSent(true);
            toast.current.show({ severity: 'success', summary: 'Succès', detail: 'Le code de vérification a été envoyé avec succès.', life: 3000 });
        } catch (error) {
            console.error('Erreur lors de l\'envoi du code de vérification:', error);
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Échec de l\'envoi du code de vérification.', life: 3000 });
        } finally {
            setLoading(false);
        }
    };

    const verifyEmail = async (code) => {
        setLoading(true);
        try {
            const response = await axiosInstance.post('/dashboard/user/me/verifyEmail', { verification_code: code });
            toast.current.show({ severity: 'success', summary: 'Succès', detail: 'Votre email a été vérifié avec succès.', life: 3000 });
            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Erreur lors de la vérification du code:', error);
            toast.current.show({ severity: 'error', summary: 'Erreur', detail: 'Échec de la vérification du code.', life: 3000 });
        } finally {
            setLoading(false);
        }
    };

    const handleOtpChange = (value) => {
        setOtp(value);
        if (value.length === 6) {
            verifyEmail(value);
        }
    };

    return (
        <>
            <Toast ref={toast} position='bottom-right' />
            <Dialog header="Vérifiez votre email" dismissableMask={true} visible={visible} style={{ width: '50vw' }} onHide={onHide}>
                <div className="field">
                    <FloatLabel>
                        <InputText id="email" value={email} readOnly className="input is-medium" />
                        <label htmlFor="email">Email</label>
                    </FloatLabel>
                </div>

                {codeSent ? (
                    <div className="field">
                        <label htmlFor="otp" className="label">Entrez le code</label>
                        <InputOtp
                            length={6}
                            id="otp"
                            value={otp}
                            onChange={(e) => handleOtpChange(e.value)}
                            className="input is-medium"
                            integerOnly
                            disabled={loading}
                        />
                    </div>
                ) : (
                    <div className="field">
                        <Button
                            label="Envoyer le code de vérification"
                            onClick={sendVerificationEmail}
                            loading={loading}
                            className="button is-primary is-medium"
                        />
                    </div>
                )}
            </Dialog>
        </>
    );
};

export default EmailVerificationDialog;